import http from '@/http';

export default class AreaProcessoService {

	update(areaProcesso) {
        console.log('update areaProcesso...', areaProcesso);
		return http.put(`selecao-estagio-area/${areaProcesso.id}`, areaProcesso).then(res => res.data);
    }

	create(areaProcesso) {
		console.log('create areaProcesso...');
		return http.post('selecao-estagio-area', areaProcesso).then(res => res.data);
    }

	delete(areaProcesso) {
		console.log('delete areaProcesso...');
		return http.delete(`selecao-estagio-area/${areaProcesso.id}`).then(res => res.data);
    }

	getAreaProcesso(selecaoId) {
		return http.get(`selecao-estagio-area/selecao/${selecaoId}`).then(res => res.data);
	}

}
